module.exports = {
    /**
     * Constante: TIMEOUT
     * Timeout.
     */
    TIMEOUT: 40000 //ms
};



//////////////////
// WEBPACK FOOTER
// ./src/DMap/Action/RequestManagerConstants.js
// module id = 189
// module chunks = 0